export interface GapLockSnapshot {
  policyNo: string;
  flow: 'policy' | 'warranty';
  premiumGrosze: number;
  variant: string;
  productCode: string;
  productName: string;
}

const LOCK_PREFIX = 'gap_lock_';
const LEAD_PREFIX = 'gap_lead_';

export function lockSnapshotKey(policyNo: string): string {
  return `${LOCK_PREFIX}${policyNo}`;
}

export function leadDedupKey(policyNo: string): string {
  return `${LEAD_PREFIX}${policyNo}`;
}

export function saveLockSnapshot(snapshot: GapLockSnapshot): void {
  if (typeof sessionStorage === 'undefined' || !snapshot.policyNo) {
    return;
  }
  sessionStorage.setItem(lockSnapshotKey(snapshot.policyNo), JSON.stringify(snapshot));
}

export function loadLockSnapshot(policyNo: string): GapLockSnapshot | null {
  if (typeof sessionStorage === 'undefined' || !policyNo) {
    return null;
  }
  const raw = sessionStorage.getItem(lockSnapshotKey(policyNo));
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as GapLockSnapshot;
  } catch {
    return null;
  }
}

export function markLeadSent(policyNo: string): boolean {
  if (typeof sessionStorage === 'undefined' || !policyNo) {
    return false;
  }
  const key = leadDedupKey(policyNo);
  if (sessionStorage.getItem(key)) {
    return false;
  }
  sessionStorage.setItem(key, '1');
  return true;
}
